import { SxProps, Theme } from '@mui/material';

export const stylesFolderLineIconButton = {
  mt: -2,
  px: 2,
  minWidth: 'initial',
  '.MuiSvgIcon-root': {
    m: '5px',
  },
};
export const stylesFolderLineTable = {
  '.MuiTableCell-head': {
    py: 3,
  },
  '.MuiTypography-subtitle1': {
    color: 'grey.800',
  },
  '.MuiTypography-body1': {
    fontSize: 'body2.fontSize',
  },
  '.MuiTypography-body2': {
    color: 'grey.400',
  },
  '.MuiNativeSelect-select': {
    fontSize: 'body2.fontSize',
  },
  cursor: 'pointer',
};
export const stylesFolderLineTableLate = {
  cursor: 'pointer',
  '.MuiTableCell-head': {
    py: 3,
  },
  '.MuiTypography-subtitle1': {
    color: 'grey.800',
  },
  '.MuiTypography-body1': {
    fontSize: 'body2.fontSize',
  },
  '.MuiTypography-body2': {
    color: 'grey.400',
  },
  '.MuiNativeSelect-select': {
    fontSize: 'body2.fontSize',
  },
  backgroundColor: '#FFD6E2 !important',
  border: '1px solid #D9214E !important',
};
export const stylesFolderLineDirection = {
  display: 'flex',
  alignItems: 'center',
};
export const stylesFolderLineDirectionInfo = {
  pt: 1,
};
export const stylesFolderLineDirectionDeparture = {
  mb: '12px',
  lineHeight: 1,
  fontWeight: 'fontWeightMedium',
};
export const stylesFolderLineDirectionArrival = {
  fontWeight: 'fontWeightMedium',
};
export const stylesFolderLineDirectionImg = {
  height: '48px',
  mr: 2,
};
export const stylesFolderLineTypology: SxProps<Theme> = {
  fontSize: 'bodySM.fontSize',
};

export const stylesFolderLineCustomer = {};
export const stylesFolderLineClientName: SxProps<Theme> = {
  fontWeight: 'fontWeightSemiBold',
  fontSize: 'bodySM',
};
export const stylesFolderLineClientID: SxProps<Theme> = {
  fontSize: 'bodyXS',
  textTransform: 'uppercase',
};

export const stylesFolderLineVm = {
  px: 2,
  py: 1,
  width: 'fit-content',
  display: 'block',
  borderRadius: 1,
};

export const stylesFolderLineVmTractor = {
  backgroundColor: 'grey.200',
  borderColor: '',
};

export const stylesFolderLineVmTrailor = {
  mb: 2,
  border: '1px solid',
  borderColor: 'grey.200',
  backgroundColor: 'white',
};

export const stylesFolderLineSpsBadge: SxProps<Theme> = {
  display: 'inline-block',
  fontSize: 'bodySM.fontSize',
  backgroundColor: 'warning.lighter',
  color: 'grey.800',
  fontWeight: 'medium',
  px: 1,
  py: '2px',
  borderRadius: 1,
};

export const stylesFolderLineVrns = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};
export const stylesFolderLineVrnsImg = { width: '28px', margin: '8px' };

export const stylesDayBeforeCrossing: SxProps<Theme> = {
  color: 'grey.400',
  fontWeight: 400,
  fontSize: 'bodySM.fontSize',
};
export const stylesDay: SxProps<Theme> = {
  ...stylesDayBeforeCrossing,
};
export const stylesVehicleIcons = {
  width: '28px',
  marginRight: 8,
};
export const stylesVehicleBox = { display: 'flex', alignItems: 'center', gap: 2 };
export const stylesVehicleCommon: SxProps<Theme> = {
  fontSize: 'bodySM.fontSize',
  letterSpacing: 0.8,
  textTransform: 'uppercase',
  border: 1,
  borderRadius: 1,
  px: 2,
};
export const stylesVehicleTractor: SxProps<Theme> = { ...stylesVehicleCommon, borderColor: 'divider' };
export const stylesVehicleTrailor: SxProps<Theme> = {
  ...stylesVehicleCommon,
  backgroundColor: 'grey.200',
  borderColor: 'transparent',
};
export const stylesFolderLineInternalReferenceText: SxProps<Theme> = { fontSize: 'bodySM.fontSize' };
export const stylesFolderNumber: SxProps<Theme> = { color: 'grey.400', fontSize: 'bodySM.fontSize' };

export const stylesFolderBookingTransportReference: SxProps<Theme> = { fontSize: 'bodySM.fontSize' };
